export const CHECK_YOUR_EMAIL = 'checkYourEmail';
